import React, { useState, useEffect } from "react";
import { Route, Redirect } from "react-router-dom"; import { getAccessToken } from "layouts/AuthUtils.js";

const PrivateRoute = ({ component: Component, requiredEndpoint, ...rest }) => {
  const [accessToken, setAccessToken] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const fetchToken = async () => {
      const token = await getAccessToken();
      setAccessToken('token');
      // console.log("token ", token)
      setIsAuthenticated(!!token);
      setLoading(false);
    };

    fetchToken();
  }, []);

  const selectedEndpoint = localStorage.getItem("selectedEndpoint");

  if (loading) {
    return <div>Loading...</div>;
  }
  return (
    <Route
      {...rest}
      render={(props) => {
        if (!isAuthenticated) {
          return <Redirect to="/auth/signin" />;
        }
        else if (requiredEndpoint && selectedEndpoint !== requiredEndpoint) {
          return <Redirect to="/admin/dashboard" />;
        }
        else {
          return <Component {...props} />;
        }
      }}
    />
  );
};

export default PrivateRoute;
